export type DeTranslationsType = typeof deTranslations;

export const deTranslations = {
  translation: {
    actions: 'Handlungen',
    activate: 'Aktivieren',
    active: 'Aktiv',
    activity: 'Aktivität',
    allSchoolClasses: 'Klassen der Schule',
    allSchoolGroups: 'Gruppen der Schule',
    allSchoolStudents: 'Schüler/innen der Schule',
    analysisBoard: 'Schachpartie analysieren',
    answer: 'Antwort',
    assign: 'Zuweisen',
    assignment: 'Kontrollarbeit',
    assignments: 'Kontrollarbeit',
    assignmentsPage: {
      addAssignment: 'Erfassen der Kontrollarbeit',
      assignmentConsistOf: 'Kontrollarbeit besteht aus',
      callToActionCreate: 'Generieren Sie eine Kontrollarbeit',
      checkpointMessage: 'Diese Kontrollarbeit gilt als Zertifizierungsaufgabe. Viel Glück!',
      chooseClass: 'Wählen Sie die Klasse, um die passende Aufgaben zu bekommen.',
      chooseGroup: 'Wählen Sie die Klasse, um die passende Aufgaben zu bekommen.',
      chooseTopics: 'Wählen Sie Themen (bis zu fünf).',
      createAssignment: 'Kontrollarbeit erstellen',
      createdList: 'Alle von Ihnen erstellten Prüfungsaufgaben werden auf dieser Seite angezeigt.',
      deadlines: 'Geben Sie die Ausführungsfristen an.',
      editAssignment: 'Kontrollarbeit bearbeiten',
      noAssignment: 'Hier fehlt die Kontrollarbeit',
      noTopics: 'Themen für diese Klasse sind nicht gefunden.',
      noTopicsForClass: 'Themen für diese Klasse sind nicht gefunden.',
      noTopicsForGroup: 'Themen für diese Gruppe sind nicht gefunden.',
      quarter: 'Für Vierteljahr',
      taskHasFinished: 'Aufgabe erledigt',
      taskNotStarted: 'Aufgabe nicht angefangen',
    },
    attempt: 'Der Versuch',
    attempts: 'Die Versuche',
    attention: 'Achtung!',
    auth: {
      auth: 'Autorisierung',
      changeEmail: 'E-Mail ändern',
      changePassword: 'Kennwort ändern',
      checkEmail: 'Prüfen Sie Ihre E-Mail!',
      confirmPassword: 'Passwort wiederholen!',
      email: 'E-Mail',
      enter: 'Einloggen',
      enterEmail: 'Geben Sie Ihre E-Mail Adresse ein.',
      enterNewPassword: 'Geben Sie ein neues Passwort ein.',
      errorOldPassword: 'Neues Passwort muss sich vom alten unterscheiden.',
      finishRegister: 'Registrierung abschließen',
      forgotPassword: 'Haben Sie Ihr Passwort vergessen?',
      incorrectLogin: 'Ungültiges Login bzw. Passwort.',
      inviteSchoolAccepted: 'Sie haben Einladung an neue Schule bekommen!',
      inviteWrongCode: 'Einladung bzw. ihr Ablaufdatum ist ungültig.',
      login: 'Login',
      newPassword: 'Neues Passwort',
      password: 'Kennwort',
      passwordMinLength: 'Mindestens 6 Zeichen',
      pleaseCheckEmail: 'Bitte überprüfen Sie Ihre E-Mail-Adresse.',
      recoverPassword: 'Passwort wiederherstellen',
      resetPassword: 'Passwort zurücksetzen',
      resetPasswordHelpMessage:
        'Oder Sie können sich an den Coach wenden, um Ihr Passwort zurückzusetzen.',
      resetPasswordMessage: 'Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen.',
      schoolNotActive: 'Schule ist nicht aktiviert.',
      schoolNotActiveCoach:
        'Ihre Schule hat keinen Zugang ins Chess Class-System, bitte kontaktieren Sie den Betreuer von der Schule.',
      schoolNotActiveStudent:
        'Ihre Schule hat keinen Zugang ins Chess Class-System, bitte kontaktieren Sie ihr/en Lehrer/in.',
      schoolNotActiveSuperCoach:
        'Ihre Schule hat keinen Zugang ins Chess Class-System, bitte kontaktieren Sie das Support-Team {{supportEmail}}.',
      send: 'Senden',
      sendConfirmation:
        'Wir haben Ihnen E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts geschickt.',
      updatePassword: 'Passwort erneuern',
      userInactive: 'Benutzer mit dieser E-Mail-Adresse ist gesperrt.',
      userNotActive: 'Benutzer ist nicht aktiviert.',
      welcome: 'Herzlich willkommen',
      welcomeToChess: "Herzlich willkommen <br />in Chess <span class='text-primary'>Class</span>",
    },
    author: 'Der Erfasser',
    authors: 'Die Erfasser',
    back: 'Zurück',
    birthDate: 'Geburtsdatum',
    boardEditorPage: {
      black: 'Schwarz',
      blacksMove: 'Schwarz am Zug',
      boardEditor: 'Brettbearbeiter',
      castling: 'Rochade',
      clearTheBoard: 'Brett leeren',
      nextMove: 'Nächster Zug',
      startingPosition: 'Anfangsstellung',
      turnTheBoardOver: 'Brett umdrehen',
      white: 'Weiß',
      whitesMove: 'Weiß am Zug',
    },
    cancel: 'Aufheben',
    cartoon: 'Cartoon',
    chapter: 'Das Thema',
    chapter_few: 'Die Themen',
    chapter_many: 'Die Themen',
    chapter_other: 'Die Themen',
    chapters: 'Die Themen',
    chaptersPage: {
      chapterList: 'Themenauflistung',
      recommendationForCoach: 'Empfehlung für den Coach!',
    },
    choose: 'Wählen Sie aus',
    chooseLanguage: 'Wählen Sie die Sprache aus',
    class: 'die Klasse',
    classStudio: 'Klassenstudio',
    classWork: 'Schularbeit',
    classes: 'Die Klassen',
    classesPage: {
      activateStudentMessage:
        'Sind Sie sicher, dass Sie dem Schüler den Zugang ins System erteilen möchten {{fullName}}?',
      addClass: 'Klasse hinzufügen',
      addGroup: 'Gruppe hinzufügen',
      addStudent: 'Schüler hinzufügen',
      assignClass: 'Klasse zuweisen',
      assignGroup: 'Gruppe zuweisen',
      backToClasses: 'Zurück zu den Klassen',
      backToGroups: 'Zurück zu den Gruppen',
      classLetter: 'Buchstabe der Klasse',
      classNumber: 'Nummer der Klasse',
      createClass: 'Klasse erstellen',
      createGroup: 'Gruppe erstellen',
      deactivateStudentMessage:
        'Sind Sie sicher, dass Sie dem Schüler den Zugang ins System entziehen möchten {{fullName}}?',
      deleteClassMessage:
        'Sind Sie sicher, dass Sie die Klasse {{grade}} “{{symbol}}” entfernen möchten?',
      deleteGroupMessage: 'Möchten Sie wirklich die Gruppe “{{symbol}}” entfernen?',
      editClass: 'Klasse bearbeiten',
      editCoach: 'Coach bearbeiten',
      editGroup: 'Gruppe bearbeiten',
      editStudent: 'Schüler bearbeiten',
      editTeacher: 'Lehrer bearbeiten',
      educationLanguage: 'Unterrichtssprache',
      excludeFromClass: 'Aus der Klasse entfernen',
      excludeFromGroup: 'Aus der Gruppe entfernen',
      excludeFromSchool: 'Aus der Schule entfernen',
      excludeStudentFromClass:
        'Sind Sie sicher, dass Sie {{fullName}} aus der Klasse entfernen möchten?',
      excludeStudentFromGroup:
        'Sind Sie sicher, dass Sie {{fullName}} aus der Gruppe entfernen möchten?',
      excludeStudentFromSchool:
        'Sind Sie sicher, dass Sie {{fullName}} aus der Schule entfernen möchten?',
      exportPdf: 'PDF herunterladen',
      groupNumber: 'Nummer der Gruppe',
      loginGenerate: "Login wird im Feld 'E-Mail' generiert",
      myClasses: 'Meine Klassen',
      myGroups: 'Meine Gruppen',
      myStudents: 'Meine Schüler',
      noGrades: 'Bewertungen sind noch nicht vergeben',
      noHomework: 'Hier fehlt die Hausarbeit',
      noIndependentWork: 'Hier fehlen selbständige Aufgaben',
      noStudents: 'Hier fehlen Schüler',
      resetPassword: 'Passwort zurücksetzen',
      studentPasswordGenerate: 'Das Passwort des Schülers wird aus dem Geburtsdatum generiert',
      studentsCount: 'Anzahl der Schüler',
      successActivateStudentMessage: 'Der Schüler wurde erfolgreich aktiviert.',
      successDeactivateStudentMessage: 'Der Schüler wurde erfolgreich deaktiviert.',
      successExcludeStudentFromClassMessage:
        'Der Schüler wurde erfolgreich aus der Klasse entfernt.',
      successExcludeStudentFromGroupMessage:
        'Der Schüler wurde erfolgreich aus der Gruppe entfernt.',
      successExcludeStudentFromSchoolMessage:
        'Der Schüler wurde erfolgreich aus der Schule entfernt.',
      tableEmptyPlaceholder:
        'Die Schüler werden hier erscheinen, nachdem sie Ihrer Schule beigetreten sind.',
      unassigned: 'Nicht zugeordnet',
    },
    clear: 'Löschen',
    coach: 'Der Coach',
    coaches: 'Die Coaches',
    content: 'Inhalt',
    copied: 'Kopiert',
    copy: 'Kopieren',
    correctLessonsCount: 'Aufgaben, richtig',
    create: 'Generieren',
    date: 'Datum',
    delete: 'Löschen',
    edit: 'Editieren',
    email: 'e-mail',
    executionReport: 'Ausführungsbericht',
    exercise: 'Übung',
    exerciseStatus: {
      FAILED: 'Nicht richtig',
      HOORAYGOODANSWER: 'Hurra! Es ist die richtige Antwort!',
      NA: 'Nicht ausgeführt',
      SOLVED: 'gelöst',
    },
    exercises: 'Übungen',
    exit: 'Ausgang',
    filter: 'Filter',
    finish: 'Beenden',
    finishAt: 'Ausführungsdatum',
    finishDate: 'Ausführungsfrist',
    fio: 'Initialen',
    firstName: 'Vorname',
    gender: {
      boy: 'Junge',
      female: 'Frau',
      girl: 'Mädchen',
      male: 'Mann',
      title: 'Geschlecht',
    },
    givenDate: 'Erteilt',
    goBack: 'zurückgehen',
    grade: 'Note',
    grades: 'Noten',
    group: 'Gruppe',
    groupStudio: 'Gruppenstudio',
    groups: 'Gruppen',
    guideline: 'Das methodische Hilfsbuch',
    guidelines: 'Die methodischen Hilfsbücher',
    help: 'Hilfe',
    helpModal: {
      haveQuestions: 'Haben Sie Fragen?',
      helpText: 'Wenn Sie Fragen haben, können Sie uns per E-Mail kontaktieren.',
    },
    hide: 'Ausblenden',
    homeWorkIsDone: 'Hausaufgabe ist erledigt',
    homework: 'Hausaufgabe',
    homeworks: 'Hausaufgaben',
    homeworksPage: {
      addHomework: 'Hausaufgabe erstellen',
      attempts: 'Die Versuche',
      callToActionCreate: 'Erstellen Sie die Hausaufgabe',
      chooseClass: 'Wählen Sie die Klasse, und wir schlagen Ihnen passende Themen vor.',
      chooseGroup: 'Wählen Sie die Gruppe, und wir schlagen Ihnen passende Themen vor.',
      chooseTopic: 'Wählen Sie das Thema.',
      completed: 'Ausgeführt',
      correctTasksCount: '{{count}} / {{total}} der Aufgaben, richtig',
      createHomework: 'Hausaufgabe generieren',
      createdList: 'Alle von Ihnen erstellten Hausaufgaben werden auf dieser Seite angezeigt.',
      currentDeadLine: 'Äußerste Frist',
      deadlines: 'Geben Sie die Ausführungsfristen an.',
      deadlinesEdit: 'Ausführungsfrist bearbeiten',
      deleteHomeworkMessage: 'Sind Sie sicher, dass Sie wirklich “{{name}}” löschen möchten?',
      editDueDate: 'Ausführungsfrist bearbeiten',
      execute: 'Anfangen',
      homework: 'Hausaufgaben',
      homeworkConsistOf: 'Hausaufgabe besteht aus',
      issued: 'Erteilt',
      newDeadLine: 'Neue äußerste Frist',
      noTopicsForClass: 'Für diese Klasse wurden keine Themen gefunden.',
      noTopicsForGroup: 'Für diese Gruppe wurden keine Themen gefunden.',
      possible: '/ {{count}} möglicher',
      startHomeworkMessage: 'Möchten Sie wirklich mit der Hausaufgabe beginnen?',
      startIndependentMessage: 'Möchten Sie wirklich mit der selbständigen Arbeit beginnen?',
      successEditDueDateChange: 'Ausführungsfrist der Hausaufgabe wurde erfolgreich geändert.',
      task: 'Aufgabe',
      tasks: 'Aufgaben',
      toAllStudents: 'Allen Schülern',
      usedAttemptsCount: 'Anzahl der ausgenutzten Versuche',
      watchChapter: 'Thema anschauen',
    },
    iin: 'Individuelle Identifikationsnummer',
    independentWork: 'Selbständige Arbeit',
    independentWorks: 'Selbständige Aufgaben',
    invalidEmail: 'Ungültige E-Mail',
    language: {
      de: 'Duits',
      en: 'Englisch',
      fr: 'Frans',
      kz: 'Kasachisch',
      ru: 'Russisch',
    },
    lastName: 'Name',
    lesson: 'Unterricht',
    lessons: 'Unterrichte',
    lessonsPage: {
      firstLevel: '1st level',
      fourthLevel: '4th level',
      secondLevel: '2nd level',
      thirdLevel: '3rd level',
      topicsMessage: 'Hier sind die abgeschlossenen Unterrichtsthemen ersichtlich.',
      welcomeToChess: "Herzlich willkommen <br />in Chess <span class='text-primary'>Class</span>",
    },
    login: 'Login',
    materials: 'Zusätzliche Materialen',
    messages: {
      birthDateShouldNotBeInTheFuture: 'Das Geburtsdatum sollte nicht in der Zukunft liegen',

      chapterNotSelected: 'Chapter is not selected',
      dueDateCannotBeEarlierThanStartDate:
        'Die Ausführungsfrist kann nicht vor dem Startdatum liegen.',

      dueDateCannotBeEarlierThanTheCurrentDate:
        'Die Ausführungsfrist kann nicht vor dem aktuellen Datum liegen.',
      error: 'Fehler aufgetreten, versuchen Sie es erneut!',
      errorEmailAlreadyUsed: 'E-Mail-Adresse wird bereits verwendet.',
      errorPostReview: 'Fehler beim Speichern der Bewertung.',
      errorProfileNotFound: 'Profil nicht gefunden.',
      errorUserNotFound: 'Benutzer nicht gefunden.',
      studentNotSelected: 'Student not selected',
      successAdminInvite: 'Einladung an das Personal wurde verschickt.',
      successAssignmentCreate: 'Kontrollarbeit wurde erfolgreich erstellt!',
      successAssignmentDelete: 'Kontrollarbeit wurde erfolgreich gelöscht!',
      successAssignmentEdit: 'Kontrollarbeit wurde erfolgreich bearbeitet!',
      successAuthorDelete: 'Autor wurde erfolgreich gelöscht!',
      successAuthorEdit: 'Autor wurde erfolgreich bearbeitet!',
      successChapterCreate: 'Thema wurde erfolgreich erstellt!',
      successChapterDelete: 'Thema wurde erfolgreich gelöscht!',
      successChapterEdit: 'Thema wurde erfolgreich bearbeitet!',
      successChapterGive: 'Thema wurde erfolgreich zugewiesen!',
      successClassCreate: 'Klasse wurde erfolgreich erstellt!',
      successClassDelete: 'Klasse wurde erfolgreich gelöscht!',
      successClassEdit: 'Klasse wurde erfolgreich bearbeitet!',
      successCoachDelete: 'Coach wurde erfolgreich gelöscht!',
      successCoachEdit: 'Coach wurde erfolgreich bearbeitet!',
      successExerciseDelete: 'Übung wurde erfolgreich gelöscht!',
      successExerciseGroupDelete: 'Übungsgruppe wurde erfolgreich gelöscht!',
      successExerciseGroupEdit: 'Übungsgruppe wurde erfolgreich bearbeitet!',
      successGroupCreate: 'Gruppe wurde erfolgreich erstellt!',
      successGroupDelete: 'Gruppe wurde erfolgreich gelöscht!',
      successGroupEdit: 'Gruppe wurde erfolgreich bearbeitet!',
      successHomeworkCreate: 'Hausaufgabe wurde erfolgreich erstellt!',
      successHomeworkDelete: 'Hausaufgabe wurde erfolgreich gelöscht!',
      successPasswordInvoke:
        'E-Mail zum Zurücksetzen des Passworts wurde an Ihre Mailbox gesendet.',
      successPasswordUpdate: 'Passwort wurde erfolgreich aktualisiert!',
      successProfileEdit: 'Profil wurde erfolgreich bearbeitet!',
      successRegister: 'Registrierung war erfolgreich!',
      successReviewPost: 'Bewertung wurde erfolgreich gespeichert!',
      successSchoolDelete: 'Schule wurde erfolgreich gelöscht!',
      successStaffDelete: 'Personal wurde erfolgreich gelöscht!',
      successStaffEdit: 'Personal wurde erfolgreich bearbeitet!',
      successStudentAddToClass: 'Schüler/in wurde erfolgreich zur Klasse hinzugefügt!',
      successStudentAddToGroup: 'Schüler/in wurde erfolgreich zur Gruppe hinzugefügt!',
      successStudentCreate: 'Schüler/in wurde erfolgreich erstellt!',
      successStudentEdit: 'Schüler/in wurde erfolgreich bearbeitet!',
      successVideoDelete: 'Video wurde erfolgreich gelöscht!',
      successVideoEdit: 'Video wurde erfolgreich bearbeitet!',
      successVideoFileDelete: 'Videodatei wurde erfolgreich gelöscht!',
      successVideoFileEdit: 'Videodatei wurde erfolgreich bearbeitet!',
      successVideoFileUpload:
        'Videodatei wurde erfolgreich hochgeladen und wird in Kürze verfügbar sein.',
      warningAssignmentConsistOf: 'Die Kontrollarbeit muss mindestens 1 Aufgabe enthalten.',
      warningHomeworkConsistOf: 'Die Hausaufgabe muss mindestens 1 Aufgabe/Test enthalten.',
      warningSession:
        'Die Sitzung ist abgelaufen oder das Format ist falsch. Bitte versuchen Sie es später erneut.',
      warningStudentEmail:
        'Ein Schüler/eine Schülerin mit dieser E-Mail-Adresse wurde bereits registriert.',
    },
    middleName: 'Vatersname',
    modals: {
      exerciseAttemptsTooltipDescription:
        'Die Gesamtzahl der Versuche können Sie nach Ihrem Ermessen pro Aufgabe verwenden oder auf mehrere Aufgaben verteilen. Nutzen Sie die Versuche sinnvoll, um die Effizienz der einzelnen Aufgaben zu maximieren.',
      exerciseAttemptsTooltipTitle: 'Ihnen werden die Versuche gewährt, um die Aufgaben zu lösen.',
      exerciseHelpText:
        'Die meisten Versuche wurden bereits genutzt. Versuchen Sie, zu den anderen Aufgaben überzugehen, um Ihre Punktzahl zu verbessern und Ihre Chancen auf den erfolgreichen Abschluss zu erhöhen.',
      goodLuck: 'Erfolg!',
      incorrectAnswer: 'falsch',
      mustAnswerAllQuestions: 'Alle Fragen sind zu beantworten!',
      tryAgain: 'Versuche erneut',
    },
    more: 'mehr',
    newestFirst: 'Neue zuerst',
    next: 'weiter',
    no: 'nein',
    noResult: 'Keine Ergebnisse entdeckt.',
    notFoundResult: {
      chooseClass: 'Wählen Sie die Klasse.',
      chooseGroup: 'Wählen Sie die Gruppe.',
      createClass: 'Generieren Sie eine Klasse.',
      createClassHelpMessage: "Man kann eine neue Klasse in der Leiste 'Klassen' generieren.",
      createGroup: 'Generieren Sie eine Gruppe.',
      createGroupHelpMessage: "Man kann eine neue Gruppe in der Leiste 'Gruppen' generieren.",
      goBackToAssignments: "Gehen Sie zur Leiste 'Alle Prüfungsaufgaben' zurück.",
      goBackToHomeworks: "Gehen Sie zur Leiste 'Alle Hausaufgaben' zurück.",
      noAssignment: 'Kontrollarbeit wurde nicht gefunden.',
      noChapterExercises: 'Zu diesem Thema wurden keine Aufgaben hinzugefügt.',
      noChapters: 'Themen sind nicht gefunden.',
      noCoach: 'Coach ist nicht gefunden.',
      noHomework: 'Hausarbeit ist nicht gefunden.',
      noHomeworkExercises: 'Aufgaben in der Hausarbeit sind nicht gefunden.',
      noLessons: 'Aufgaben sind nicht gefunden.',
      noMaterials: 'Zu diesem Thema wurde kein weiteres Material hinzugefügt.',
      noStudent: 'Schüler/in ist nicht gefunden.',
    },
    oldestFirst: 'Alte zuerst',
    passed: 'Bestanden',
    pause: 'Aussetzen',
    phone: 'Telefon',
    phoneNumber: 'Telefonnummer',
    problem: 'Die Aufgabe',
    problem_few: 'Die Aufgaben',
    problem_many: 'Der Aufgaben',
    problem_other: 'Der Aufgaben',
    problems: 'Die Aufgaben',
    proceed: 'Starten',
    profile: 'Profil',
    profilePage: {
      birthDate: 'Geburtsdatum',
      email: 'Email',
      emailPlaceholder: 'Geben Sie die e-mail ein.',
      firstName: 'Vorname',
      gender: 'Geschlecht',
      genderPlaceholder: 'Wählen Sie das Geschlecht aus.',
      iin: 'Individuelle Identifikationsnummer',
      lastName: 'Name',
      loginAndPassword: 'Login und Passwort',
      loginHelpText: "Login wird im Feld 'email' generiert.",
      middleName: 'Vatersname',
      passwordRepeatError: 'Dieses Kennwort wurde schon einmal verwendet, erstellen Sie ein neues.',
      personalInfo: 'Persönliche Angaben',
      phone: 'Telefon',
      phonePlaceholder: 'Geben Sie die Telefonnummer ein.',
      profileSettings: 'Einstellungen des Profils',
      schoolAndCoach: 'Schule und Coach',
      schoolAndTeacher: 'Schule und Lehrer/in',
      withoutCoach: 'Ohne Coach',
      withoutCoachHelpText: 'Sie sind noch mit keinem Coach verbunden.',
      withoutTeacher: 'Ohne Lehrer/in',
      withoutTeacherHelpText: 'Sie sind noch mit keinem Lehrer verbunden.',
    },
    report: 'Bericht',
    requiredField: 'Dieses Feld ist erforderlich',
    result: 'Ergebnis',
    results: 'Ergebnisse',
    review: {
      review: 'Bewerten',
      reviewChapter: 'Bitte bewerten Sie dieses Thema.',
      reviewExercise: 'Bitte bewerten Sie diese Aufgabe.',
      reviewLesson: 'Bitte bewerten Sie diesen Unterricht.',
      reviewTest: 'Bewerten Sie die Fragen der Eigenarbeit, die Sie soeben bearbeitet haben.',
      reviewVideo: 'Bitte bewerten Sie das angesehene Video.',
      tellUsMoreDetails: 'Erzählen Sie ausführlicher.',
      thisWillHelpUpToImprove: 'Das hilft uns, diese zu verbessern.',
      whatDidYouLike: 'Teilen Sie uns mit, was Ihnen besonders gefallen hat.',
      whatYouDidntLike: 'Teilen Sie uns mit, was Ihnen nicht gefallen hat.',
    },
    save: 'Speichern',
    school: 'Die Schule',
    schools: 'Die Schulen',
    search: 'Suche',
    searchHelpText: 'Ändern Sie Ihre Suche.',
    seeDetails: 'Details anzeigen',
    selfWorkIsDone: 'Selbständige Arbeit ist erledigt.',
    show: 'Zeigen',
    solution: 'Lösung',
    solvedCount: 'Ausgeführt',
    startAt: 'Ausführungsdatum',
    startDate: 'Anfangsdatum',
    status: 'Status',
    statuses: {
      ACTIVE: 'Aktiv',
      ALL: 'All',
      AVAILABLE: 'Verfügbar',
      BESTANDEN: 'Bestanden',
      DELETED: 'Gelöscht',
      DISABLED: 'Gesperrt',
      DRAFT: 'Entwurf',
      FAILED: 'Falsch',
      FINISHED: 'Beendigt',
      GIVEN: 'Erteilt',
      INACTIVE: 'Vorläufig eingestellt',
      INVITED: 'Eingeladen',
      ISSUED: 'Erteilt',
      NA: 'Nicht ausgeführt',
      NEW: 'Neu',
      NOT_AVAILABLE: 'Nicht erreichbar',
      NOT_INVITED: 'Nicht eingeladen',
      NOT_ISSUED: 'Nicht erteilt',
      NOT_PASSED: 'Nicht bestanden',
      PAUSED: 'Ausgesetzt',
      SOLVED: 'Gelöst',
    },
    student: 'Der Schüler / Die Schülerin',
    studentDetails: 'Details des Schülers / der Schülerin',
    studentProfile: 'Profil des Schülers / der Schülerin',
    student_few: 'des Schülers / der Schülerin',
    student_many: 'der Schüler / der Schülerinnen',
    student_other: 'der Schüler / der Schülerinnen',
    students: 'Die Schüler/innen',
    studio: 'Studio',
    studiosPage: {
      alertEndLesson: 'Möchten Sie den Unterricht wirklich beenden?',
      attemptsLeft: 'verbleibende Versuche',
      available: 'Verfügbar',
      chooseAnswer: 'Wählen Sie die Antwort aus.',
      chooseClass: 'Wählen Sie den Unterrichtsraum aus.',
      chooseGroup: 'Wählen Sie die Gruppe aus.',
      demonstrationsStudio: 'Studium für Vorführungen',
      endLesson: 'Unterricht beenden',
      findTheBestMoveFor: 'Finden Sie den besten Zug für...',
      findTheBestMoveForBlack: 'Finden Sie den besten Zug für Schwarz.',
      findTheBestMoveForWhite: 'Finden Sie den besten Zug für Weiß.',
      giveHomeWork: 'Hausarbeit erteilen',
      given: 'Erteilt',
      hideAnswer: 'Antwort verbergen',
      hideSolution: 'Lösung verbergen',
      showAnswer: 'Antwort anzeigen',
      showSolution: 'Lösung anzeigen',
      studioView: 'Vorführung des Unterrichtsstudios',
      viewMoves: 'Übersicht von Zügen',
      weWillSuggest: 'Wir schlagen Ihnen ein passendes Thema und Übungen vor.',
      yourMove: 'Ihr Zug',
    },
    successPasswordResetMessage: 'Passwort wurde erfolgreich zurückgesetzt.',
    superCoach: 'Der Betreuer / Die Betreuerin',
    superCoaches: 'Die Betreuer/innen',
    teacher: 'Der Lehrer / Die Lehrerin',
    teachers: 'Die Lehrer/innen',
    test: 'Test',
    tests: 'Tests',
    time: 'Zeit',
    title: 'Bezeichnung',
    total: 'Insgesamt',
    tryAgainLater: 'Versuchen Sie später erneut',
    type: 'Typ',
    understand: 'Klar',
    videofiles: 'Video-Dateien',
    videolesson: 'Video-Unterricht',
    yes: 'Ja',
    youHaveMoreAttempts:
      'Du hast noch übrige Versuche, du kannst zurückkommen und dein Ergebnis verbessern.',
    yourResult: 'Dein Ergebnis',
  },
};
